<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
      <ion-img src="/assets/icons/icon-72x72.png" style="max-width: 45px; max-height: 45px;" *ngIf="config.logoInHeader"></ion-img>
      <ion-title *ngIf="config.titelInHeader" style="text-transform: uppercase;">{{config.titel}}</ion-title>
  </ion-buttons>
    <ion-title>Passwort ändern</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-item>
    <ion-label position="stacked">Aktuelle Passwort</ion-label>
    <ion-input [style.--color]="config.inputHintergrundFarbe" [(ngModel)]="oldPassword" type="password"></ion-input>
  </ion-item>
  <ion-item>
    <ion-label position="stacked">Neues Passwort</ion-label>
    <ion-input [style.--color]="config.inputHintergrundFarbe" [(ngModel)]="newPassword" type="password"></ion-input>
  </ion-item>
  <ion-item>
    <ion-label position="stacked">Neues Passwort bestätigen</ion-label>
    <ion-input [style.--color]="config.inputHintergrundFarbe" [(ngModel)]="newPassword2" type="password"></ion-input>
  </ion-item>
  <ion-button [disabled]="oldPassword === '' || newPassword === '' || newPassword !== newPassword2 || oldPassword === newPassword" (click)="change()">
    <ion-icon slot="start" name="bookmark"></ion-icon>
    Passwort ändern
  </ion-button>
  <ion-item color="danger" *ngIf="error">
    {{errorText}}
  </ion-item>
  <ion-item color="secondary" *ngIf="success">
    Das Passwort wurde geändert!
  </ion-item>
</ion-content>
